import { render, staticRenderFns } from "./CatalogLink.vue?vue&type=template&id=a4da7b02&"
import script from "./CatalogLink.vue?vue&type=script&lang=ts&"
export * from "./CatalogLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports